import { createSlice } from "@reduxjs/toolkit";
import { defaultState } from "../../../interfaces/auth";
import { changeStatusThunk } from "../../../asyncThunks/manage/mapping";

const initialState: defaultState = {
    error: null,
    data: null,
    loading: false,
};

export const changeEmployeeStatus = createSlice({
    name: "addEmployee",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(changeStatusThunk.pending, (state, action) => {
            state.error = null;
            state.data = null;
            state.loading = true;
        });
        builder.addCase(changeStatusThunk.fulfilled, (state, action) => {
            if (action?.payload?.status?.toLowerCase() === "success") {
                state.error = null;
                state.data = action.payload;
            } else {
                state.error = action?.payload;
                state.data = null;
            }
            state.loading = false;
        });
        builder.addCase(changeStatusThunk.rejected, (state, action) => {
            state.error = action.payload;
            state.data = null;
            state.loading = false;
        });
    },
});

export default changeEmployeeStatus.reducer;
